import { Stepper, Step, StepLabel, Box } from "@mui/material";

interface StepperComponentProps {
  activeStep: number;
  steps: string[];
}

const StepperComponent = ({ activeStep, steps }: StepperComponentProps) => {
  return (
    <Box sx={{ width: "100%", mb: 4 }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map(label => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default StepperComponent; 